package com.tregz.tremenz.ui.media

import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.tregz.tremenz.ui.icon.IconKey
import com.tregz.tremenz.ui.icon.iconPainter
import com.tregz.tremenz.ui.label.LabelKey
import com.tregz.tremenz.ui.label.labelText

@Composable
actual fun MediaCast(
    isInfoOpen: Boolean,
    onInfoToggle: () -> Unit,
    modifier: Modifier
) {
    IconButton(onClick = onInfoToggle) {
        Icon(
            painter = iconPainter(if (isInfoOpen) IconKey.TV else IconKey.INFO),
            contentDescription = labelText(if (isInfoOpen) LabelKey.INFO_HIDE else LabelKey.INFO_SHOW),
            modifier = modifier
        )
    }
}
